// extracted by mini-css-extract-plugin
export default {"root":"tags_root__HfS+2","label":"tags_label__3rBYg","tagsContainer":"tags_tagsContainer__zguJ3","tag":"tags_tag__tceCg"};